import { createAction, props } from '@ngrx/store';

const ACCEPT_AI_DATA_MODEL = '[AI Application DataModel] Accept AI Application DataModel';
const ACCEPT_AI_DATA_MODEL_SUCC = '[AI Application DataModel] Accept AI Application DataModel Success';
const ACCEPT_AI_DATA_MODEL_FAIL = '[AI Application DataModel] Accept AI Application DataModel Failure';
const REJECT_AI_DATA_MODEL = '[AI Application DataModel] Reject AI Application DataModel';
const REJECT_AI_DATA_MODEL_SUCC = '[AI Application DataModel] Reject AI Application DataModel Success';
const REJECT_AI_DATA_MODEL_FAIL = '[AI Application DataModel] Reject AI Application DataModel Failure';
const UPDATE_AI_MODEL = '[AI Application DataModel] Update AI Application DataModel';
const UPDATE_AI_MODEL_SUCC = '[AI Application DataModel] Update AI Application DataModel Success';
const UPDATE_AI_MODEL_FAIL = '[AI Application DataModel] Update AI Application DataModel Failure';
const GENERATE_MODEL_FOR_TABLE_PROMPT = '[AI Application DataModel] Generate Model For Table Prompt';
const GENERATE_MODEL_FOR_TABLE_PROMPT_SUCC = '[AI Application DataModel] Generate Model For Table Prompt Success';
const GENERATE_MODEL_FOR_TABLE_PROMPT_FAIL = '[AI Application DataModel] Generate Model For Table Prompt Failure';
const GENERATE_MODEL_FOR_FIELD_PROMPT = '[AI Application DataModel] Generate Model For Field Prompt';
const GENERATE_MODEL_FOR_FIELD_PROMPT_SUCC = '[AI Application DataModel] Generate Model For Field Prompt Success';
const GENERATE_MODEL_FOR_FIELD_PROMPT_FAIL = '[AI Application DataModel] Generate Model For Field Prompt Failure';

const acceptAiDataModel = createAction(ACCEPT_AI_DATA_MODEL, props<{ apiConstants: any; params }>());

const acceptAiDataModelSuccess = createAction(ACCEPT_AI_DATA_MODEL_SUCC, props<{ acceptSuccessData: any }>());

const acceptAiDataModelFailure = createAction(ACCEPT_AI_DATA_MODEL_FAIL, props<{ acceptFailureData: any }>());

const rejectAiDataModel = createAction(REJECT_AI_DATA_MODEL, props<{ apiConstants: any; params }>());

const rejectAiDataModelSuccess = createAction(REJECT_AI_DATA_MODEL_SUCC, props<{ rejectSuccessData: any }>());

const rejectAiDataModelFailure = createAction(REJECT_AI_DATA_MODEL_FAIL, props<{ rejectFailureData: any }>());

const updateAIDM = createAction(UPDATE_AI_MODEL, props<{ updApiConstants: any; aiDMData: any }>());

const updateAIDMSuccess = createAction(UPDATE_AI_MODEL_SUCC, props<{ aiDMSuccData: any }>());

const updateAIDMFail = createAction(UPDATE_AI_MODEL_FAIL, props<{ aiDMFailData: any }>());

const generateModelForTablePrompt = createAction(
  GENERATE_MODEL_FOR_TABLE_PROMPT,
  props<{ apiConstants: any; params }>()
);

const generateModelForTablePromptSuccess = createAction(
  GENERATE_MODEL_FOR_TABLE_PROMPT_SUCC,
  props<{ generateModelForTablePromptSuccData: any }>()
);

const generateModelForTablePromptFailure = createAction(
  GENERATE_MODEL_FOR_TABLE_PROMPT_FAIL,
  props<{ generateModelForTablePromptFailData: any }>()
);

const generateModelForFieldPrompt = createAction(
  GENERATE_MODEL_FOR_FIELD_PROMPT,
  props<{ apiConstants: any; params }>()
);

const generateModelForFieldPromptSuccess = createAction(
  GENERATE_MODEL_FOR_FIELD_PROMPT_SUCC,
  props<{ generateModelForFieldPromptSuccData: any }>()
);

const generateModelForFieldPromptFailure = createAction(
  GENERATE_MODEL_FOR_FIELD_PROMPT_FAIL,
  props<{ generateModelForFieldPromptFailData: any }>()
);

export {
  acceptAiDataModel,
  acceptAiDataModelSuccess,
  acceptAiDataModelFailure,
  rejectAiDataModel,
  rejectAiDataModelSuccess,
  rejectAiDataModelFailure,
  updateAIDM,
  updateAIDMSuccess,
  updateAIDMFail,
  generateModelForTablePrompt,
  generateModelForTablePromptSuccess,
  generateModelForTablePromptFailure,
  generateModelForFieldPrompt,
  generateModelForFieldPromptSuccess,
  generateModelForFieldPromptFailure
};
